/**
 * sc-48721: credito da restituire e preventivo chiuso alle modifiche.
 */

export const MSG_PREVENTIVO_CHIUSO =
  "Preventivo pagato e con la consegna iniziata: non si modifica più.";

/**
 * Quanto va restituito al cliente quando ha pagato più del dovuto.
 * Riceve il rimanente (dovuto meno pagato): sotto zero è un credito.
 * Il rimborso avviene fuori dal gestionale; qui lo si rende visibile.
 * Sotto il mezzo centesimo non è un credito: gli arrotondamenti non
 * devono accendere il badge.
 */
export function daRestituire(rimanente) {
  const r = Number(rimanente);
  if (!Number.isFinite(r) || r > -0.005) return 0;
  return Number((-r).toFixed(2));
}

// Gemello di preventivoChiusoAlleModifiche nell'API (src/utils/quoteLock.js),
// che comunque rifiuta. Nessuno stato "In magazzino": la consegna è iniziata
// se il preventivo è Consegnato o se almeno una riga è spuntata.
export function preventivoNonModificabile(quote) {
  if (quote?.payment_state !== "Pagato") return false;
  if (quote.state === "Consegnato") return true;
  return (quote.quote_items || []).some((qi) => Boolean(qi?.isDelivered));
}
